import { render, staticRenderFns } from "./AutocompleteServiceType.vue?vue&type=template&id=b3028896"
import script from "./AutocompleteServiceType.vue?vue&type=script&lang=js"
export * from "./AutocompleteServiceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports